// extracted by mini-css-extract-plugin
export default {"lobby":"Lobby_lobby__ekyex","pageContent":"Lobby_pageContent__2KCO-","mainFold":"Lobby_mainFold__LzUAg"};